import React from 'react';
import { BaseLayoutFactory } from '../global/base-layout-factory';
import { UsefulLinksProvider } from './context/useful-links-context';
import { UsefulLinksComponent } from './useful-links-component';

export function UsefulLinksFactory() {
  return (
    <BaseLayoutFactory>
      <UsefulLinksProvider>
        <UsefulLinksComponent />
      </UsefulLinksProvider>
    </BaseLayoutFactory>
  );
}
